<template>
  <ButtonComponent
    ref="obj"
    :disabled="disabled"
    :class="_class"
    :css-class="_cssClass"
    :icon-css="_eClass"
    :title="_tooltip"
    @click="onClick"
  >
    <v-icon
      v-if="_mdiIcon"
      :icon="_mdiIcon"
      :style="_mdiIconStyle"
      class="sog-button-mdi-icon"
    />
    <slot />
  </ButtonComponent>
</template>

<script setup lang="ts">
import {ButtonComponent} from "@syncfusion/ej2-vue-buttons";
import {computed, ref} from "vue";
import {SogButtonKind} from "@/shared/ui/types/SogButtonKind";
import {useRouter} from "vue-router";
import {SogButtonType} from "@/shared/ui/types/SogButtonType";
import {SogButtonStyle} from "@/shared/ui/types/SogButtonStyle";

const emits = defineEmits(['click'])

interface Props {
  mdiIcon?: string
  disabled?: boolean | string
  eIcon?: string
  tooltip?: string
  type?: SogButtonType
  kind?: SogButtonKind
  buttonStyle?: SogButtonStyle
}

const props = withDefaults(defineProps<Props>(), {
    mdiIcon: "",
    disabled: false,
    eIcon: undefined,
    tooltip: undefined,
    type: undefined,
    kind: SogButtonKind.Default,
    buttonStyle: SogButtonStyle.Default

  }
)

const _tooltip = computed(() => {
  if (props.tooltip)
    return props.tooltip
  switch (props.kind) {
    case SogButtonKind.Edit:
      break;
    case SogButtonKind.Search:
      break;
    case SogButtonKind.Refresh:
      return "Aktualisieren."
    case SogButtonKind.Default:
      break;
    case SogButtonKind.Ok:
      break;
    case SogButtonKind.Cancel:
      return "Abbrechen."
    case SogButtonKind.Save:
      return "Klicken, um zu speichern."
    case SogButtonKind.Back:
      return "Klicken, um zurückzugehen."
    case SogButtonKind.FilterRemove:
      return "Filter löschen."
  }
  return undefined
})

const _mdiIcon = computed(() => {
  if (props.mdiIcon)
    return props.mdiIcon
  switch (props.kind) {
    case SogButtonKind.Refresh:
      return "mdi-refresh"
    case SogButtonKind.Search:
      return "mdi-magnify"
    case SogButtonKind.Edit:
      return "mdi-pencil"
    case SogButtonKind.Default:
      break;
    case SogButtonKind.Back:
      return "mdi-arrow-left-circle"
    case SogButtonKind.Ok:
      return "mdi-check"
    case SogButtonKind.Cancel:
      return "mdi-cancel"
    case SogButtonKind.Save:
      return "mdi-content-save"
    case SogButtonKind.FilterRemove:
      return "mdi-filter-remove"
    default:
      break;
  }
  return undefined
})

const _mdiIconStyle = computed(() => {
  return ""
  return "margin-right: 3px"
  //return "margin-right: 30px"
})

const obj = ref<InstanceType<typeof ButtonComponent> | null>(null)

const focus = () => {
  obj.value?.focusIn();
}

const _router = useRouter()


defineExpose({
  focus
})

const _eClass = computed(() => {
  if (props.eIcon)
    return "e-icons " + props.eIcon
  return ""
})


/*
const _disabled = computed(()=>{
  return props.disabled?.toLowerCase()==="true"?true:false
})
*/

const _class = computed(() => {
  switch (props.type) {
    case SogButtonType.Card:
      return "e-card-btn";
    case SogButtonType.Toolbar:
      return "e-tbar-btn";
    case SogButtonType.Appbar:
      return "e-inherit";
    /*
        case "success": return "e-success";
        case "primary": return "e-primary";
    */
  }
  return ""
})

const _cssClass = computed(() => {
  switch (props.buttonStyle) {
    case SogButtonStyle.Primary:
      return "e-primary";
    case SogButtonStyle.Success:
      return "e-success";
    case SogButtonStyle.Info:
      return "e-info";
    case SogButtonStyle.Warning:
      return "e-warning";
    case SogButtonStyle.Danger:
      return "e-danger";
    case SogButtonStyle.Link:
      return "e-link";
    default:
      return "";
  }
})

async function onClick() {
  emits("click")
  if (props.kind === SogButtonKind.Back) {
    _router?.back()
  }
}

</script>

<style scoped>
.sog-button-mdi-icon {
  margin-right: 3px;
}

</style>
